import { useMemo } from "react";
import {
  ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
} from "recharts";
import { money } from "../lux";

// Revenue bars + net profit line, one bucket per calendar month of the
// recognition date. Bookings with unusable dates never get a bucket.
export function RevenueProfitChart({ monthly }) {
  const data = useMemo(
    () => (monthly || []).map((m) => ({
      month: m.month,
      Revenue: Math.round(m.revenue),
      "Net profit": Math.round(m.net_profit),
    })),
    [monthly],
  );
  if (!data.length) {
    return <div className="text-sm text-muted-foreground py-14 text-center">No dated bookings in this range to chart.</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={320}>
      <ComposedChart data={data} margin={{ top: 12, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
        <XAxis dataKey="month" tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} />
        <YAxis tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} />
        <Tooltip
          formatter={(v) => money(v)}
          contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="Revenue" fill="hsl(var(--muted-foreground))" radius={[3, 3, 0, 0]} maxBarSize={38} />
        <Line type="monotone" dataKey="Net profit" stroke="hsl(var(--primary))" strokeWidth={2} dot={{ r: 2.5 }} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
